import { render, staticRenderFns } from "./TaskFormModal.vue?vue&type=template&id=e583ea9a&"
import script from "./TaskFormModal.vue?vue&type=script&lang=js&"
export * from "./TaskFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports